// Bootstrap 5 CSS
import "bootstrap/dist/css/bootstrap.min.css";

// FontAwesome 6 - import only needed icons
import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import {
    faBars,
    faCircle,
    faBabyCarriage,
    faBaby,
    faChild,
    faPhone,
    faCheckCircle,
    faCertificate,
    faStar,
    faHeart,
    faQuestionCircle,
    faEnvelope,
    faMapMarkerAlt
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";

// Prevent FontAwesome from adding its CSS automatically (we import it above)
config.autoAddCss = false;

// Add icons to library and watch DOM for icon replacement
library.add(
    faBars,
    faCircle,
    faBabyCarriage,
    faBaby,
    faChild,
    faPhone,
    faFacebookF,
    faGoogle,
    faCheckCircle,
    faCertificate,
    faStar,
    faHeart,
    faQuestionCircle,
    faEnvelope,
    faMapMarkerAlt
);
dom.watch();

import "../css/agency.css";

import "./agency";
import "./reviews";
